import { uuid } from "@/config/normalConfig";
import {
  createSetting,
  getSettingById,
  updateSetting,
} from "@/fetch/fetchCommission";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import moment from "moment";
import { setGlobalMessage } from "./systemSlice";
const initialState = {
  validations: {
    transferProductCommissions: [],
    transferAmounts: [],
    productCommissions: [],
    mutiLocations: [],
    commissionLevels: [],
    specialCommissionLevels: [],
    productBonus: [],
    specialShifts: [],
    bonus: {
      bounsAmount: false,
      specialBounsCondition: false,
      specialBounsAmount: false,
    },
    adjustment: [],
  },
  settings: {
    currentDate: null,
    transferProductCommissions: [],
    transferAmounts: [],
    productCommissions: [],
    specialShifts: [],
    productBonus: [],
    specialCommissionLevels: {
      promoter: [],
      schmea_name: "",
      schmea: [],
    },
    mutiLocations: { promoter: [] },
    directSales: [],
    bonus: {
      bounsAmount: 1000,
      specialBounsCondition: 100000,
      specialBounsAmount: 2500,
    },
    adjustment: [],
    commissionLevels: [],
  },
};
export const fetchSetting = createAsyncThunk(
  "commission/fetchSetting",
  async (id, { fulfillWithValue }) => {
    const { data: setting } = await getSettingById(id);
    const convertProductCommission = [];
    _.forEach(setting.products_commission, (products_commission) => {
      const parentId = uuid();
      _.forEach(products_commission.requirement, (requirement, index) => {
        convertProductCommission.push({
          id: requirement.id ? requirement.id : index !== 0 ? uuid() : parentId,
          parentId: requirement.parentId
            ? requirement.parentId
            : index === 0
              ? null
              : parentId,
          startDate: products_commission.startDate,
          endDate: products_commission.endDate,
          productIds: products_commission.productIds ?? [],
          excludeCommission: requirement.excludeCommission,
          commission: requirement.commission,
          name: requirement.name,
          minQty: requirement.minQty,
          maxQty: requirement.maxQty,
          isDisabled: index > 0,
        });
      });
    });
    const convertProductBonus = [];
    _.forEach(setting.product_bouns, (product_bouns) => {
      const parentId = uuid();
      _.forEach(product_bouns.requirement, (requirement, index) => {
        convertProductBonus.push({
          id: requirement.id ? requirement.id : index !== 0 ? uuid() : parentId,
          parentId: requirement.parentId
            ? requirement.parentId
            : index === 0
              ? null
              : parentId,
          startDate: product_bouns.startDate,
          endDate: product_bouns.endDate,
          productIds: product_bouns.productIds ?? [],
          currentQty: product_bouns.currentQty,
          bouns: requirement.bouns,
          name: requirement.name,
          minQty: requirement.minQty,
          maxQty: requirement.maxQty,
          isDisabled: index > 0,
        });
      });
    });
    return fulfillWithValue({
      currentDate: moment(setting.date).format("YYYY-MM-DD"),
      directSales: setting.direct_sales,
      bonus: setting.bouns,
      specialCommissionLevels: setting.special_sales_commission,
      commissionLevels: setting.sales_commission,
      productBonus: convertProductBonus,
      specialShifts: setting.special_shift,
      adjustment: setting.adjustment,
      mutiLocations: { promoter: setting.muti_location },
      transferProductCommissions: setting.transfer_product_commissions,
      transferAmounts: setting.transfer,
      productCommissions: convertProductCommission,
    });
  },
);
export const saveSetting = createAsyncThunk(
  "commission/saveSetting",
  async (id, { getState, dispatch, rejectWithValue, fulfillWithValue }) => {
    const state = getState();
    const settings = state.commission.settings;
    const currentDate = state.commission.settings.currentDate;
    const {
      productCommissions,
      productBonus,
      mutiLocations,
      specialShifts,
      commissionLevels,
      specialCommissionLevels,
      transferProductCommissions,
      transferAmounts,
      adjustment,
      bonus,
    } = settings;
    const groupProductCommissionFormDatas = _.groupBy(
      productCommissions,
      (r) => r.parentId ?? r.id,
    );
    const groupProductBonusFormDatas = _.groupBy(
      productBonus,
      (r) => r.parentId ?? r.id,
    );
    const commissionLevelFormErr = commissionLevels.map((item, index, arr) => {
      let amountErr = "";
      let percentageErr = "";

      const func1 = () => {
        if (item.amount === null) {
          amountErr = "不能為空值";
        }
        if (!item.percentage) {
          percentageErr = "不能為空值";
        }
        return amountErr || percentageErr;
      };

      const func2 = () => {
        if (isNaN(parseInt(item.amount))) {
          amountErr = "必須為數值";
        }
        if (isNaN(parseInt(item.percentage))) {
          percentageErr = "必須為數值";
        }

        return amountErr || percentageErr;
      };

      func1();
      func2();

      return { amountErr, percentageErr };
    });
    const specialCommissionLevelFormErr = specialCommissionLevels.schmea.map(
      (item, index, arr) => {
        let amountErr = "";
        let percentageErr = "";

        const func1 = () => {
          if (item.amount === null) {
            amountErr = "不能為空值";
          }
          if (!item.percentage) {
            percentageErr = "不能為空值";
          }
          return amountErr || percentageErr;
        };

        const func2 = () => {
          if (isNaN(parseInt(item.amount))) {
            amountErr = "必須為數值";
          }
          if (isNaN(parseInt(item.percentage))) {
            percentageErr = "必須為數值";
          }

          return amountErr || percentageErr;
        };

        func1();
        func2();

        return { amountErr, percentageErr };
      },
    );
    const productCommissionFormErr = productCommissions.map(
      (item, index, arr) => {
        const obj = {
          startDateErr: "",
          endDateErr: "",
          productIdsErr: "",
          commissionErr: "",
          minQtyErr: "",
          maxQtyErr: "",
          nameErr: "",
        };

        const func1 = () => {
          [
            "startDate",
            "endDate",
            "productIds",
            "commission",
            "minQty",
            "maxQty",
            "name",
          ].forEach((key) => {
            if (item[key] === null || item[key] === "") {
              obj[`${key}Err`] = "不能為空值";
            }
          });

          if (parseInt(item["minQty"]) >= parseInt(item["maxQty"])) {
            obj[`minQtyErr`] = "必須小於最多目標數量";
            obj[`maxQtyErr`] = "必須大於最少目標數量";
          }
          return Object.values(obj).some((item) => item && true);
        };
        const func2 = () => {
          if (isNaN(parseInt(item.commission))) {
            obj.commissionErr = "必須為數值";
          }
          if (
            parseInt(item.maxQty) <= parseInt(item.minQty) &&
            parseInt(item.maxQty) !== 0
          ) {
            obj.maxQtyErr = "必須大於最少目標數量";
          }
          return obj.commissionErr || obj.minQtyErr || obj.maxQtyErr;
        };

        const func3 = () => {
          if (item.startDate > item.endDate) {
            obj.startDateErr = `不能大於${item?.endDate}`;
          }
          return obj.startDateErr;
        };

        func1();
        func2();
        func3();

        return obj;
      },
    );
    _.forEach(
      groupProductCommissionFormDatas,
      (groupProductCommissionFormData) => {
        if (groupProductCommissionFormData.length > 1) {
          let lastQty = parseInt(groupProductCommissionFormData[0].maxQty);
          _.forEach(groupProductCommissionFormData, (data, index) => {
            if (index === 0) return;
            if (lastQty >= parseInt(data.minQty)) {
              const errIndex = _.findIndex(
                productCommissions,
                (p) => p.id === data.id,
              );
              productCommissionFormErr[errIndex].minQtyErr =
                "必須大於上一層的最多目標數";
              productCommissionFormErr[errIndex - 1].maxQtyErr =
                "必須大於下一層的最少目標數";
            }
            lastQty = parseInt(data.maxQty);
          });
        }
      },
    );
    const productBonusFormErr = productBonus.map((item, index, arr) => {
      const obj = {
        startDateErr: "",
        endDateErr: "",
        productIdsErr: "",
        bounsErr: "",
        minQtyErr: "",
        maxQtyErr: "",
        nameErr: "",
      };

      const func1 = () => {
        [
          "startDate",
          "endDate",
          "productIds",
          "commission",
          "minQty",
          "maxQty",
          "bouns",
          "name",
        ].forEach((key) => {
          if (item[key] === null || item[key] === "") {
            obj[`${key}Err`] = "不能為空值";
          }
        });

        if (parseInt(item["minQty"]) >= parseInt(item["maxQty"])) {
          obj[`minQtyErr`] = "必須小於最多目標數量";
          obj[`maxQtyErr`] = "必須大於最少目標數量";
        }
        return Object.values(obj).some((item) => item && true);
      };

      const func2 = () => {
        if (isNaN(parseInt(item.bouns))) {
          obj.bounsErr = "必須為數值";
        }

        if (isNaN(parseInt(item.minQty))) {
          obj.minQtyErr = "必須為數值";
        }
        if (isNaN(parseInt(item.maxQty))) {
          obj.maxQtyErr = "必須為數值";
        }

        if (
          parseInt(item.maxQty) <= parseInt(item.minQty) &&
          parseInt(item.maxQty) !== 0
        ) {
          obj.maxQtyErr = "必須大於最少目標數量";
        }
        return obj.bounsErr || obj.minQtyErr || obj.maxQtyErr;
      };

      const func3 = () => {
        if (item.startDate > item.endDate) {
          obj.startDateErr = `不能大於${item.endDate}`;
        }
        return obj.startDateErr;
      };

      func1();
      func2();
      func3();

      return obj;
    });

    _.forEach(groupProductBonusFormDatas, (groupProductBonusFormDat) => {
      if (groupProductBonusFormDat.length > 1) {
        let lastQty = parseInt(groupProductBonusFormDat[0].maxQty);
        _.forEach(groupProductBonusFormDat, (data, index) => {
          if (index === 0) return;
          if (lastQty >= parseInt(data.minQty)) {
            const errIndex = _.findIndex(productBonus, (p) => p.id === data.id);
            productBonusFormErr[errIndex].minQtyErr =
              "必須大於上一層的最多目標數";
            productBonusFormErr[errIndex - 1].maxQtyErr =
              "必須大於下一層的最少目標數";
          }
          lastQty = parseInt(data.maxQty);
        });
      }
    });
    const bonusFormErr = {
      bounsAmountErr: isNaN(parseInt(bonus.bounsAmount)) ? "必須為數值" : false,
      specialBounsAmountErr: isNaN(parseInt(bonus.specialBounsAmount))
        ? "必須為數值"
        : false,
      specialBounsConditionErr: isNaN(parseInt(bonus.specialBounsCondition))
        ? "必須為數值"
        : false,
    };
    const transferFromErr = transferAmounts.map((item) => {
      const obj = {
        dateErr: "",
        transferAmountErr: "",
      };

      if (
        moment(currentDate).format("YYYY-MM") !==
        moment(item.date).format("YYYY-MM")
      ) {
        obj.dateErr = `日期必需在${moment(currentDate).format("YYYY年MM月內")}`;
      }

      const total = _.sumBy(transferAmounts, (r) =>
        parseFloat(r.transferAmount),
      );

      if (total > 0) {
        obj.transferAmountErr = `總和必須小於0，現總和為${total}`;
      }

      return obj;
    });
    const specialShiftsFormErr = specialShifts.map((item) => {
      const obj = {
        dateErr: "",
        remarkErr: "",
      };
      if (
        moment(currentDate).format("YYYY-MM") !==
        moment(item.date).format("YYYY-MM")
      ) {
        obj.dateErr = `日期必需在${moment(currentDate).format("YYYY年MM月內")}`;
      }
      if (!item.remark) {
        obj[`remarkErr`] = "不能為空值";
      }

      return obj;
    });

    const groupTransferProductCommissionByQtyAndProducts = _.groupBy(
      transferProductCommissions,
      (t) => `${Math.abs(t.transferQty)}@${t.productId}`,
    );
    const transferProductCommissionTotal = _.sumBy(
      transferProductCommissions,
      (r) => parseFloat(r.transferQty),
    );
    const transferProductCommissionsFromErr = transferProductCommissions.map(
      (item) => {
        const obj = {
          dateErr: "",
          transferQtyErr: "",
        };

        if (
          moment(currentDate).format("YYYY-MM") !==
          moment(item.date).format("YYYY-MM")
        ) {
          obj.dateErr = `日期必需在${moment(currentDate).format("YYYY年MM月內")}`;
        }

        if (transferProductCommissionTotal > 0) {
          obj.transferQtyErr = `總和必須小於0，現總和為${transferProductCommissionTotal}`;
        }
        if (
          _.some(
            groupTransferProductCommissionByQtyAndProducts,
            (g) => g.length !== 2,
          )
        ) {
          obj.transferQtyErr = `調整數量必須為一對`;
        }
        return obj;
      },
    );
    const adjustFormErr = adjustment.map((item) => {
      const obj = {
        remarkErr: "",
        adjustAmountErr: "",
      };

      if (!item.remark) {
        obj.remarkErr = `不能為空值`;
      }
      if (!item.adjustAmount) {
        obj.adjustAmountErr = `不能為空值`;
      }
      return obj;
    });
    const isCommissionLevelFormValid = commissionLevelFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.amountErr, cur.percentageErr]),
        [],
      )
      .every((item) => item === "");
    const isSpecialCommissionLevelFormValid = specialCommissionLevelFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.amountErr, cur.percentageErr]),
        [],
      )
      .every((item) => item === "");
    const isProductCommissionFormValid = productCommissionFormErr
      .reduce(
        (prev, cur) =>
          (prev = [
            ...prev,
            cur.startDateErr,
            cur.endDateErr,
            cur.productIdsErr,
            cur.commissionErr,
            cur.minQtyErr,
            cur.maxQtyErr,
            cur.nameErr,
          ]),
        [],
      )
      .every((item) => item === "");

    const isProductBonusValid = productBonusFormErr
      .reduce(
        (prev, cur) =>
          (prev = [
            ...prev,
            cur.startDateErr,
            cur.endDateErr,
            cur.productIdsErr,
            cur.bounsErr,
            cur.minQtyErr,
            cur.maxQtyErr,
            cur.nameErr,
          ]),
        [],
      )
      .every((item) => item === "");
    const isBonusFormValid =
      !bonusFormErr.bounsAmountErr &&
      !bonusFormErr.specialBounsAmountErr &&
      !bonusFormErr.specialBounsConditionErr;
    const isTransferFromValid = transferFromErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.transferAmountErr, cur.dateErr]),
        [],
      )
      .every((item) => item === "");
    const isTransferProductCommissionsFromValid =
      transferProductCommissionsFromErr
        .reduce(
          (prev, cur) => (prev = [...prev, cur.transferQtyErr, cur.dateErr]),
          [],
        )
        .every((item) => item === "");
    const isSpecialShiftValid = specialShiftsFormErr
      .reduce((prev, cur) => (prev = [...prev, cur.dateErr, cur.remarkErr]), [])
      .every((item) => item === "");

    const isAdjustFormValid = adjustFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.remarkErr, cur.adjustAmountErr]),
        [],
      )
      .every((item) => item === "");
    if (
      !isCommissionLevelFormValid ||
      !isSpecialShiftValid ||
      !isSpecialCommissionLevelFormValid ||
      !isProductCommissionFormValid ||
      !isProductBonusValid ||
      !isBonusFormValid ||
      !isTransferFromValid ||
      !isTransferProductCommissionsFromValid ||
      !isAdjustFormValid
    ) {
      dispatch(
        setGlobalMessage({
          message: {
            severity: "error",
            isError: true,
            code: 500,
            message: "更新失敗，請填寫所有資料",
          },
        }),
      );
      return rejectWithValue({
        value: {
          transferProductCommissions: !isTransferProductCommissionsFromValid
            ? transferProductCommissionsFromErr
            : [],

          transferAmounts: !isTransferFromValid ? transferFromErr : [],
          productCommissions: !isProductCommissionFormValid
            ? productCommissionFormErr
            : [],
          mutiLocations: [],
          commissionLevels: !isCommissionLevelFormValid
            ? commissionLevelFormErr
            : [],
          specialCommissionLevels: !isSpecialCommissionLevelFormValid
            ? specialCommissionLevelFormErr
            : [],
          productBonus: !isProductBonusValid ? productBonusFormErr : [],
          specialShifts: !isSpecialShiftValid ? specialShiftsFormErr : [],
          bonus: !isBonusFormValid ? bonusFormErr : [],
          adjustment: !isAdjustFormValid ? adjustFormErr : [],
        },
      });
    } else {
      const convertProductCommissionFormData = [];
      _.forEach(groupProductCommissionFormDatas, (rows) => {
        const { endDate, productIds, startDate, excludeCommission } = rows[0];
        const requirement = [];
        _.forEach(rows, (row) => {
          requirement.push({
            id: row.id,
            parentId: row.parentId,
            maxQty: row.maxQty,
            minQty: row.minQty,
            commission: row.commission,
            excludeCommission: row.excludeCommission,
            name: row.name,
          });
        });
        convertProductCommissionFormData.push({
          excludeCommission,
          productIds,
          endDate: moment(endDate).format("YYYY-MM-DD"),
          startDate: moment(startDate).format("YYYY-MM-DD"),
          requirement,
        });
      });

      const convertProductBonusFormData = [];
      _.forEach(groupProductBonusFormDatas, (rows) => {
        const { endDate, productIds, startDate, currentQty } = rows[0];
        const requirement = [];
        _.forEach(rows, (row) => {
          requirement.push({
            id: row.id,
            parentId: row.parentId,
            maxQty: row.maxQty,
            minQty: row.minQty,
            bouns: row.bouns,
            name: row.name,
          });
        });
        convertProductBonusFormData.push({
          productIds,
          endDate: moment(endDate).format("YYYY-MM-DD"),
          startDate: moment(startDate).format("YYYY-MM-DD"),
          currentQty,
          requirement,
        });
      });
      const reqBody = {
        sales_commission: commissionLevels,
        special_sales_commission: specialCommissionLevels,
        products_commission: convertProductCommissionFormData,
        adjustment: adjustment,
        product_bouns: convertProductBonusFormData,
        muti_location: mutiLocations.promoter,
        bouns: bonus,
        special_shift: specialShifts,
        transfer: transferAmounts,
        transfer_product_commissions: transferProductCommissions,
        date: moment(currentDate).format("YYYY-MM-01"),
      };
      let result = null;
      if (id) {
        result = await updateSetting(id, reqBody);
      } else {
        result = await createSetting(reqBody);
      }
      dispatch(
        setGlobalMessage({
          message: {
            severity: "success",
            code: 200,
            message: "更新成功,請重新計算佣金",
          },
        }),
      );
      return fulfillWithValue(result);
    }
  },
);

export const commissionSlice = createSlice({
  name: "commission",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(saveSetting.fulfilled, (state) => {
        state.validations = initialState.validations;
      })
      .addCase(saveSetting.rejected, (state, action) => {
        state.validations = action.payload.value;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.settings = action.payload;
      });
  },
  reducers: {
    reset: () => {
      return initialState;
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    setSettingByIndex: (state, action) => {
      const { key, value, index } = action.payload;
      state.settings[key][index] = value;
    },
    setSettingByKey: (state, action) => {
      const { key, value } = action.payload;
      state.settings[key] = value;
    },
    removeSettingByIndex: (state, action) => {
      const { key, index } = action.payload;
      state.settings[key].splice(index, 1);
    },
    addSetting: (state, action) => {
      const { key, value } = action.payload;
      state.settings[key].push({ ...value, id: uuid() });
    },
    copySetting: (state, action) => {
      const { key, value, index } = action.payload;
      state.settings[key].splice(index + 1, 0, {
        ...value,
        id: uuid(),
      });
    },
    setValidations: (state, action) => {
      const { value } = action.payload;
      state.validations = value;
    },
    setValidationsByKey: (state, action) => {
      const { value, key } = action.payload;
      state.validations[key] = value;
    },
    resetValidations: (state, action) => {
      state.validations = initialState.validations;
    },
    setDefaultSetting: (state, action) => {
      const { date } = action.payload;
      const startDate = moment(date).startOf("month");
      const endDate = moment(date).endOf("month");
      const globalLabParentId = uuid();
      const taiWahParentId = uuid();
      state.settings = initialState.settings;
      state.settings.currentDate = date;
      state.settings.commissionLevels = [
        { id: uuid(), amount: 50000, percentage: 8 },
        { id: uuid(), amount: 50000, percentage: 8 },
        { id: uuid(), amount: 5000, percentage: 13.5 },
        { id: uuid(), amount: 5000, percentage: 13.75 },
        { id: uuid(), amount: 5000, percentage: 14 },
        { id: uuid(), amount: 5000, percentage: 14.25 },
        { id: uuid(), amount: 5000, percentage: 14.5 },
        { id: uuid(), amount: 5000, percentage: 14.75 },
        { id: uuid(), amount: 5000, percentage: 15 },
        { id: uuid(), amount: 5000, percentage: 15.25 },
        { id: uuid(), amount: 5000, percentage: 15.5 },
        { id: uuid(), amount: 5000, percentage: 15.75 },
        { id: uuid(), amount: 5000, percentage: 16 },
        { id: uuid(), amount: 5000, percentage: 16.25 },
        { id: uuid(), amount: 5000, percentage: 16.5 },
        { id: uuid(), amount: 5000, percentage: 16.75 },
        { id: uuid(), amount: 5000, percentage: 17 },
        { id: uuid(), amount: 5000, percentage: 17.25 },
        { id: uuid(), amount: 5000, percentage: 17.5 },
        { id: uuid(), amount: 5000, percentage: 17.75 },
        { id: uuid(), amount: 110000, percentage: 18 },
        { id: uuid(), amount: 100000, percentage: 18.25 },
        { id: uuid(), amount: 100000, percentage: 18.5 },
        { id: uuid(), amount: 99999999999, percentage: 18.75 },
      ];
      state.settings.productCommissions = [
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [35, 73, 72, 71, 70, 41, 30, 33, 32, 240, 34],
          excludeCommission: true,
          commission: 15,
          name: "Return External $15",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [44],
          excludeCommission: true,
          commission: 15,
          name: "ShaoYeh $15",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [282, 167, 280, 152, 281, 151],
          excludeCommission: true,
          commission: 5,
          name: "INNE $5",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [149, 258, 148, 150, 147],
          excludeCommission: true,
          commission: 0,
          name: "INNE $0",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [255],
          excludeCommission: true,
          commission: 0,
          name: "LUNA $0",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [235, 272],
          excludeCommission: true,
          commission: 10,
          name: "Tai Wah $10",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [237, 238],
          excludeCommission: true,
          commission: 2,
          name: "Tai Wah $2",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [221, 269],
          excludeCommission: true,
          commission: 5,
          name: "Tai Wah $5",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: uuid(),
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          excludeCommission: true,
          commission: 100,
          name: "Tai Wah 100",
          minQty: -999,
          maxQty: "9999999",
          isDisabled: false,
        },
        {
          id: globalLabParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [4],
          excludeCommission: false,
          commission: 0,
          name: "theGlobalab 跳bar",
          minQty: -999,
          maxQty: "120",
          isDisabled: false,
        },
        {
          id: uuid(),
          parentId: globalLabParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [4],
          excludeCommission: true,
          commission: 15,
          name: "theGlobalab $15",
          minQty: 121,
          maxQty: "9999999",
          isDisabled: true,
        },
      ];
      state.settings.productBonus = [
        {
          id: taiWahParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          currentQty: 0,
          bouns: "1000",
          name: "Tai Wah ＄1000",
          minQty: "6",
          maxQty: "9",
          isDisabled: false,
        },
        {
          id: uuid(),
          parentId: taiWahParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          currentQty: 0,
          bouns: "1800",
          name: "Tai Wah ＄1800",
          minQty: 10,
          maxQty: "11",
          isDisabled: true,
        },
        {
          id: uuid(),
          parentId: taiWahParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          currentQty: 0,
          bouns: "2000",
          name: "Tai Wah ＄2000",
          minQty: 12,
          maxQty: "15",
          isDisabled: true,
        },
        {
          id: uuid(),
          parentId: taiWahParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          currentQty: 0,
          bouns: "3000",
          name: "Tai Wah ＄3000",
          minQty: 16,
          maxQty: "19",
          isDisabled: true,
        },
        {
          id: uuid(),
          parentId: taiWahParentId,
          startDate: startDate,
          endDate: endDate,
          productIds: [239],
          currentQty: 0,
          bouns: "3600",
          name: "Tai Wah ＄3600",
          minQty: 20,
          maxQty: "99999",
          isDisabled: true,
        },
      ];
    },
  },
});

export const {
  setValidations,
  setValidationsByKey,
  resetValidations,
  reset,
  setSettings,
  setSettingByKey,
  setSettingByIndex,
  removeSettingByIndex,
  copySetting,
  addSetting,
  setDefaultSetting,
} = commissionSlice.actions;

export default commissionSlice.reducer;
